import { BeachVolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const SetWonPopup = new PopupBuilder('Set won', {
  incident_id: BeachVolleyballIncidentId.SetWon,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
